import AbstractService from "./AbstractService";
import NexusService from "./NexusService";

export default class NonRKPayInvoiceService extends AbstractService {
	static nonRkPayInvoiceApi = NexusService.nonRKPayInvoiceApi;

	static unfinalize(id) {
		return this.nonRkPayInvoiceApi.unfinalize({ id }).then(response => {
			const apiResponse = {
				data: response,
			};
			return apiResponse;
		});
	}
}
